import styled from "styled-components";
import { theme } from "../../../theme";
import { Container } from "../../../common/styles";
import { Link } from "react-router-dom";

export const Section = styled(Container)`
    flex-direction: row;
    background-color: ${theme.colors.colorfulBackground};
    background-image: url("./background.png");
    background-repeat: no-repeat;
    background-size: 250px;
    background-position: 0 15px;
    background-blend-mode: soft-light;
    padding: 0;
    @media (max-width: ${theme.breakpoints.tablet}) {
        background-size: 170px;
    }
    @media (max-width: ${theme.breakpoints.mobile}) {
        flex-direction: column;
        background-size: 150px;
    }
`;

export const TextBlock = styled.div`
    display: flex;
    flex-direction: column;
    margin-left: auto;
    justify-content: center;
    text-align: right;
    align-items: center;
    padding: 20px 40px;
    color: ${theme.colors.white};
    max-width: 1400px;
    min-height: 200px;
    white-space: break-spaces;
    @media (max-width: ${theme.breakpoints.tablet}) {
        padding: 20px;
    }
    @media (max-width: ${theme.breakpoints.mobile}) {
        padding: 20px 15px 20px;
    }
`;

export const Img = styled.img`
    width: 50vw;
    max-width: 800px;
    object-fit: cover;
    @media (max-width: ${theme.breakpoints.tablet}) {
        width: 40vw;
    }
    @media (max-width: ${theme.breakpoints.mobile}) {
        width: 100%;
    }
`;

export const Title = styled.h2`
    margin-left: auto;
    font-size: 35px;
    margin: 0 0 20px auto;
    justify-self: flex-start;
    font-weight: ${theme.fonts.weights.superBold};
    @media (max-width: ${theme.breakpoints.tablet}) {
        font-size: 25px;
    }
`;

export const Text = styled.span`
    font-size: 20px;
    font-weight: ${theme.fonts.weights.bold};
    margin-bottom: 15px;
    @media (max-width: ${theme.breakpoints.tablet}) {
        font-size: 15px;
    }
`;

export const StyledLinkButton = styled(Link)`
    cursor: pointer;    
    padding: 12px 25px;
    margin: auto 0 0 auto;
    border-radius: 4px;
    border: 1px solid ${theme.colors.colorfulBackground}; 
    background-color: ${theme.colors.white};
    color: ${theme.colors.colorfulBackground};
    font-weight: ${theme.fonts.weights.superBold} ;
    font-size: 24px;
    transition: 300ms;
    &&:hover{
        background: none;
        transform: translateY(-5px);
        color: ${theme.colors.white};
        border-color: ${theme.colors.white};
    }
    &&:active{
        transform: translateY(0);
        transition: 0ms;
        background-color: ${theme.colors.text};
    }
    @media (max-width: ${theme.breakpoints.tablet}) {
        font-size: 14px;
        padding: 10px 20px;
    }
    @media (max-width: ${theme.breakpoints.mobile}) {
        font-size: 12px;
    }
`;